import { MESSAGE_STATUS, useApiContext } from 'react-easyrocket';
import { Navigate, useSearchParams } from 'react-router';
import { useMessage } from 'src/modules/messages';
import { useRoute } from 'src/router/hooks/useRoute';

export function SocialSignUpHandler() {
  const { saveSession } = useApiContext();
  const [searchParams] = useSearchParams();
  const { openMessage } = useMessage();
  const { ROUTE } = useRoute();

  const status = searchParams.get('status');
  const message = searchParams.get('message');
  const uuid = searchParams.get('session_uuid');

  status === 'error'
    ? openMessage({
      type: 'USER_MESSAGE',
      props: { text: message || '', status: MESSAGE_STATUS.ERROR },
      saveToHistory: false
    })
    : saveSession(uuid);
  return <Navigate to={ROUTE.MAIN.get()} />;
}
